import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    ModuleProps,
    LoadModuleById,
    setModuleView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"


const View = ({
    moduleId = null,
}: ModuleProps) => {
    const module = useSelector((state: StoreType) => state.module.moduleView)
    const reloadView = useSelector((state: StoreType) => state.module.reloadView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadModuleById(moduleId).then((res) => {
            dispatch(setModuleView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    if (!module) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewModule} # ${module.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <Form />
            </PageContent>
        </Container>
    )
}
export default View
